import { render, staticRenderFns } from "./TeachingSchedule.vue?vue&type=template&id=f2ec9f44&scoped=true&"
import script from "./TeachingSchedule.vue?vue&type=script&lang=js&"
export * from "./TeachingSchedule.vue?vue&type=script&lang=js&"
import style0 from "./TeachingSchedule.vue?vue&type=style&index=0&id=f2ec9f44&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ec9f44",
  null
  
)

export default component.exports